/**
 * Action for Fetch Service Event
 */
export enum fetchServiceEvent {
  FETCH_SERVICE_EVENT_REQUEST = 'FETCH_SERVICE_EVENT_REQUEST'
}
